import {
  CARD_PAGE_SET_CARD_DETAILS,
  CARD_PAGE_SET_CARD_STATE,
  CARD_PAGE_SET_LOADING,
  CARD_PAGE_SET_TRANSACTIONS,
  CardPageAction
} from '@Actions/cardPageActions';

import { IGetIssuingDetailsResponse } from '@ClientServices/api/cardIssuing';
import { ICardTransactionModel } from '@Shared/models';

interface ICardPageState {
  loading: boolean;
  details: IGetIssuingDetailsResponse;
  transactions: ICardTransactionModel[];
  count: number;
}

export const defaultState: ICardPageState = {
  loading: true,
  details: null,
  transactions: [],
  count: 0
};

export function cardPageReducer(state: ICardPageState = defaultState, action: CardPageAction) {
  switch (action.type) {
    case CARD_PAGE_SET_LOADING:
      return { ...state, loading: action.payload };
    case CARD_PAGE_SET_CARD_DETAILS:
      return { ...state, details: action.payload };
    case CARD_PAGE_SET_TRANSACTIONS:
      return { ...state, transactions: action.payload.rows, count: action.payload.count };
    case CARD_PAGE_SET_CARD_STATE:
      return {
        ...state,
        details: {
          ...state.details,
          state: action.payload
        }
      };
    default:
      return state;
  }
}
